import { useMutation } from '@tanstack/react-query';
import { useAppContext } from 'src/contexts/AppContext';
import { ErrorTypes, useClientLogContext } from 'src/contexts/ClientLogContext';
import { Feature, SaleClient } from 'src/WebApiController';

import { useUserHasFeature } from '../useUserHasFeature';

export function useUnwasteSale() {
  const { activeAccountWebClientConfig } = useAppContext();
  const { trackError, showErrorDialog } = useClientLogContext();
  const hasConsigneeSingleEntityUpdateFeature = useUserHasFeature(
    Feature.ConsigneeSingleEntityUpdate
  );

  return useMutation({
    mutationFn: async ({ saleId }: { saleId: number }) => {
      return hasConsigneeSingleEntityUpdateFeature
        ? await new SaleClient(
            activeAccountWebClientConfig
          ).unwasteSaleBySaleId(saleId, {
            saleId,
          })
        : await new SaleClient(activeAccountWebClientConfig).unwasteSale({
            saleId,
          });
    },
    onError: (error: ErrorTypes, { saleId }, context) => {
      trackError('SaleClient.unwasteSale', error, {
        saleId,
      });
      showErrorDialog('SaleClient.unwasteSale', error, {
        trackErrorData: { saleId },
      });
    },
  });
}
